<template>
  <div class="date-content">
    <el-radio-group v-if="showOutButton" v-model="fastIndex" size="small" @change="fastButtonChange">
      <el-radio-button :label="item" v-for="(item, index) in outButtons" :key="index"></el-radio-button>
    </el-radio-group >
    <el-button v-if="showOutPreAndNext" size="mini" @click="dateChange(0)">
      <i class="el-icon-arrow-left"></i>
    </el-button>
    <el-date-picker
      :style="{width: setWidth+''}"
      v-model="time"
      v-date-format-t
      :type="type"
      :size="size"
      :readonly="readonly"
      :disabled="disabled"
      :editable="editable"
      :clearable="clearable"
      :placeholder="placeholder"
      value-format="timestamp"
      :default-value="defaultValue"
      :picker-options="pickerOptions"
      :default-time="defaultTime"
      @change="changeTime"
    ></el-date-picker>
    <el-button v-if="showOutPreAndNext" size="mini" @click="dateChange(1)">
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'date'
      },
      size: {
        type: String,
        default: 'mini'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      editable: {
        type: Boolean,
        default: true
      },
      quickButtonsFlag: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      setWidth: {
        type: String,
        default: '100%'
      },
      outButtons: {
        type: Array,
        default: () => {
          return ['昨天','今天','明天','后天','大后天']
        }
      },
      outButtonValues: {
        type: Array,
          default: () => {
          return [new Date(new Date().setDate(new Date().getDate() - 1)),new Date(),new Date(new Date().setDate(new Date().getDate() + 1)),new Date(new Date().setDate(new Date().getDate() + 2)),new Date(new Date().setDate(new Date().getDate() + 3))]
        }
      },
      showOutButton: {
        type: Boolean,
        default: false
      },
      showOutPreAndNext: {
        type: Boolean,
        default: false
      },
      valueFormat: {
        type: String,
        default: ''
      },
      pickerOptions: {
        type: Object,
        default: () => {
          return {}
        }
      },
      defaultTime: {
        type: String,
        default: '08:00:00'
      },
      vModel: null,
    },
    data() {
      return {
        defaultValue: '',
        time: '',
        fastIndex: '',
      };
    },
    watch: {
      vModel: {
        immediate: true,
        handler(val) {
          this.time = val
        }
      },
    },
    methods: {
      changeTime(val) {
        this.setTime(val)
        this.$emit('change', val)
      },
      fastButtonChange() {
        this.time = this.outButtonValues[this.getArrayIndex(this.outButtons, this.fastIndex)]
        this.changeTime(this.time)
      },
      dateChange(flag) {
        if (!this.time)return
        let date = new Date(this.time);if (flag == 1) {this.time = new Date(date.setDate(date.getDate() + 1));} else {this.time = new Date(date.setDate(date.getDate() - 1));}
        this.changeTime(this.time)
      },
      getArrayIndex(arr, obj) {
        var i = arr.length;while (i--) {if (arr[i] === obj) {return i;}}return -1;
      },
      setTime(val) {
        this.$emit("update:vModel", val)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .date-content{width: 100%;}
</style>



// WEBPACK FOOTER //
// src/components/DateAndTime/dateSelectT.vue